import React, { useState, useEffect, useRef } from 'react'
import { Tabs, Card, Popover, Button } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import _ from 'lodash'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import {
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  initValueAndLabel,
  uniqueFun,
  isChineseFun,
  dateFormatYearMonthDay,
  initValueAndText,
  addPercentage,
  numFormat
} from '@/utils/common'
import {
  getOutboundSacnQuerySummary,
  getOutboundSacnQueryDetail,
  getOutboundScanDropList,
  getOutboundSacnQuerySummaryDownload,
  getOutboundSacnQueryDetailDownload,
  getExceptionDownload
} from '@/services/rfid/reports/rfidTunnelScanAccuracyReport'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import { BUSINESS_TYPE, CARTON_PE } from '@/utils/types'
import { modalError } from '@/utils/modalUtils'
const startMonth = dayjs().subtract(1, 'day')
const endMonth = dayjs().subtract(1, 'day')
const defaultBusinessTypeColumn = ['1', '3', '4']
// 可多选
const defaultBusinessType = ['1', '3']
// 包含其中一个不可多选
const defaultBusinessType2 = ['2', '4']
const RfidTunnelScanAccuracyReport = () => {
  let deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [tabActive, setTabActive] = useState('summary')
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [businessType, setBusinessType] = useState(defaultBusinessType)
  const [filtersObj, setFiltersObj] = useState({
    deviceCode: []
  })
  const mounting = useRef(false)
  let formRef = useRef(null)
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.rfidTunnelScanAccuracyReport.businessType',
      key: 'businessType',
      allowClear: false,
      showAll: false,
      initialValues: defaultBusinessType,
      mode: 'multiple',
      maxTagCount: 1,
      selectList: BUSINESS_TYPE,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      handleChange: (e, idx, item) => {
        setBusinessType(e)
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.rfidTunnelScanAccuracyReport.searchDate',
      key: 'rangeDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      allowClear: false
    },
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.siteType',
      key: 'siteTypes',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.siteName',
      key: 'siteNames',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidTunnelScanAccuracyReport.plant',
      key: 'plants',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidTunnelScanAccuracyReport.cartonPE',
      key: 'cartonPes',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: CARTON_PE,
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidTunnelScanAccuracyReport.vendor',
      key: 'vendors',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)

  const tableColumns1 = [
    {
      title: () => formatMessageNew('languageObj.rfidConfiguration.siteType'),
      dataIndex: 'siteType',
      width: 80,
      fixed: 'left'
    },
    {
      title: () => formatMessageNew('languageObj.rfidConfiguration.siteName'),
      dataIndex: 'siteName',
      width: 80,
      fixed: 'left'
    },
    {
      title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.plant'),
      dataIndex: 'plant',
      width: 80,
      fixed: 'left'
    }
  ]
  const tableColumnsOB2 = [
    {
      title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.solution'),
      dataIndex: 'solution',
      width: 100,
      fixed: 'left'
    }
  ]
  let tableColumns2 = [
    {
      title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.tunnelMachine'),
      dataIndex: 'deviceCode',
      width: 130,
      fixed: 'left',
      filters: [],
      // filteredValue: filtersObj.deviceCode || [],
      filterSearch: true,
      filterMultiple: true
    }
  ]
  const tableColumns3 = [
    {
      title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.cartonUnitAccuracy'),
      dataIndex: 'cartonUnitAccuracy',
      children: [
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.giedASNQty'),
          dataIndex: 'sourceQty',
          width: 170,
          onCell: record => {
            if (record.rowSpan !== undefined) {
              return {
                rowSpan: record.rowSpan
              }
            }
            return { rowSpan: 1 }
          },
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.noScan'),
          dataIndex: 'noScanQty',
          width: 150,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.scannedQty'),
          dataIndex: 'scanQty',
          width: 150,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.accurate'),
          dataIndex: 'accurateQty',
          width: 150,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.scanMissed'),
          dataIndex: 'upcMissedQty',
          width: 150,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.scanExceeded'),
          dataIndex: 'upcExceedQty',
          width: 170,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.misMatched'),
          dataIndex: 'upcMissMatchedQty',
          width: 170,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.byCartonAccuracy'),
          dataIndex: 'byCartonAccuracy',
          width: 150,
          render: text => {
            let rate = addPercentage(text)
            return <span>{rate}</span>
          }
        }
      ]
    }

    // {
    //   title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.tunnelException'),
    //   dataIndex: 'tunnelException',
    //   children: [
    //     {
    //       title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.noDataQty'),
    //       dataIndex: 'noDataQty',
    //       width: 150,
    //       render: text => {
    //         return <div>{numFormat(text)}</div>
    //       }
    //     },
    //     {
    //       title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.noDataRate'),
    //       dataIndex: 'noDataRate',
    //       width: 150,
    //       render: text => {
    //         let rate = addPercentage(text)
    //         return <span>{rate}</span>
    //       }
    //     }
    //   ]
    // }
  ]
  const tableColumnsDetail3 = [
    {
      title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.cartonUnitAccuracy'),
      dataIndex: 'cartonUnitAccuracy',
      children: [
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.scannedQty'),
          dataIndex: 'scanQty',
          width: 150,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.accurate'),
          dataIndex: 'accurateQty',
          width: 150,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.scanMissed'),
          dataIndex: 'upcMissedQty',
          width: 150,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.scanExceeded'),
          dataIndex: 'upcExceedQty',
          width: 170,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.misMatched'),
          dataIndex: 'upcMissMatchedQty',
          width: 170,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.byCartonAccuracy'),
          dataIndex: 'byCartonAccuracy',
          width: 150,
          render: text => {
            let rate = addPercentage(text)
            return <span>{rate}</span>
          }
        }
      ]
    }

    // {
    //   title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.tunnelException'),
    //   dataIndex: 'tunnelException',
    //   children: [
    //     {
    //       title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.noDataQty'),
    //       dataIndex: 'noDataQty',
    //       width: 150,
    //       render: text => {
    //         return <div>{numFormat(text)}</div>
    //       }
    //     },
    //     {
    //       title: () => formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.noDataRate'),
    //       dataIndex: 'noDataRate',
    //       width: 150,
    //       render: text => {
    //         let rate = addPercentage(text)
    //         return <span>{rate}</span>
    //       }
    //     }
    //   ]
    // }
  ]
  const [tableColumnsSunmmary, setTableColumnsSunmmary] = useState([])
  const [tableColumnsDetail, setTableColumnsDetail] = useState([
    ...tableColumns1,
    ...tableColumns2,
    ...tableColumnsDetail3
  ])
  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    if (_.intersection(businessType, defaultBusinessTypeColumn).length > 0) {
      setTableColumnsSunmmary([...tableColumns1, ...tableColumns3])
      setTableColumnsDetail([...tableColumns1, ...tableColumns2, ...tableColumnsDetail3])
    } else {
      setTableColumnsSunmmary([...tableColumns1, ...tableColumnsOB2, ...tableColumns3])
      setTableColumnsDetail([...tableColumns1, ...tableColumns2, ...tableColumnsDetail3])
    }
    // setQueryFlag(!queryFlag)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessType])
  useEffect(() => {
    getSelectOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSelectOptions = () => {
    getOutboundScanDropList().then(res => {
      tableColumns2[0].filters = initValueAndText(res.resultData.tunnels)
      setTableColumnsDetail([...tableColumns1, ...tableColumns2, ...tableColumnsDetail3])
      searchListInit.forEach(itemFirst => {
        if (
          itemFirst.key === 'siteTypes' ||
          itemFirst.key === 'siteNames' ||
          itemFirst.key === 'plants' ||
          itemFirst.key === 'vendors'
        ) {
          let arr = []
          if (itemFirst.key === 'siteTypes') {
            arr = res.resultData.siteTypes || []
          }
          if (itemFirst.key === 'siteNames') {
            arr = res.resultData.siteNames || []
          }
          if (itemFirst.key === 'plants') {
            arr = res.resultData.plants || []
          }
          if (itemFirst.key === 'vendors') {
            arr = res.resultData.vendors || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 3))
        }
      })
      setSearchList([...searchListInit])
    })
  }

  const downLoadFun = () => {
    let info = getParams()
    if (!info) {
      return
    }
    const params = {
      ...info,
      ...isChineseFun()
    }
    if (tabActive === 'summary') {
      getOutboundSacnQuerySummaryDownload(params).then(res => {
        downLoadFileBlob(res)
      })
    } else {
      params.tunnelCodes = filtersObj.deviceCode
      getOutboundSacnQueryDetailDownload(params).then(res => {
        downLoadFileBlob(res)
      })
    }
  }
  const downLoadExceptionFun = () => {
    let info = getParams()
    if (!info) {
      return
    }
    const params = {
      ...info,
      ...isChineseFun()
    }
    getExceptionDownload(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const searchDataBtn = () => {
    mounting.current = true
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    mounting.current = true
    formRef && formRef.current.clearForm()
    // setFiltersObj({
    //   deviceCode: []
    // })
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = (pagina, filters) => {
    mounting.current = true
    setFiltersObj(filters)
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { rangeDate, businessType } = info
    if (businessType && businessType.length > 1) {
      if (_.intersection(businessType, defaultBusinessType2).length > 0) {
        // "allow multiple selection for IB – Factory, IB – STO"
        modalError({ content: formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.multipleErr') })
        return false
      }
    }
    const params = {
      ...info,
      businessType,
      dateStart: formatStartTime(rangeDate),
      dateEnd: formatEndTime(rangeDate)
    }
    delete params.rangeDate
    return params
  }
  const searchDataFun = () => {
    let info = getParams()
    if (!info) {
      return
    }
    const params = {
      ...info
    }
    if (tabActive === 'summary') {
      getOutboundSacnQuerySummary(params).then(res => {
        let dt = res.resultData
        if (_.intersection(businessType, defaultBusinessTypeColumn).length === 0) {
          // OB
          for (let index = 0; index < dt.length; index++) {
            let element = dt[index]
            let element2 = dt[index + 1]
            if (element.plant === '1027' && element.solution === 'Century Lead') {
              if (element2 && element2.plant === '1027' && element2.solution === 'DFK') {
                element.rowSpan = 2
                element2.rowSpan = 0
              }
            }
            if (element.plant === '1027' && element.solution === 'DFK') {
              if (element2 && element2.plant === '1027' && element2.solution === 'Century Lead') {
                element.rowSpan = 2
                element2.rowSpan = 0
              }
            }
          }
        }
        setTableList(dt)
      })
    } else {
      params.tunnelCodes = filtersObj.deviceCode
      getOutboundSacnQueryDetail(params).then(res => {
        const dt = res.resultData
        setTableList(dt)
      })
    }
  }

  const tabChange = e => {
    setTabActive(e)
    setQueryFlag(!queryFlag)
  }
  const tabItems = [
    {
      key: 'summary',
      label: formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.summary'),
      children: (
        <AntdTable
          rowKey={record => record.id}
          // 独一无二的表示，不能重复
          columnsKey={'columns_rfidTunnelScanAccuracyReportSummary' + businessType}
          onDownload={downLoadFun}
          optStyle={{ top: -30 - deviceSize * 20 }}
          dataSource={tableList}
          columns={tableColumnsSunmmary}
        />
      )
    },
    {
      key: 'detail',
      label: formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.detail'),
      children: (
        <AntdTable
          rowKey={record => record.id}
          // 独一无二的表示，不能重复
          columnsKey={'columns_rfidTunnelScanAccuracyReportDetail' + businessType}
          onDownload={downLoadFun}
          optStyle={{ top: -30 - deviceSize * 20 }}
          dataSource={tableList}
          columns={tableColumnsDetail}
          onChange={handleTableChange}
        />
      )
    }
  ]
  const getPopoverContent = () => {
    return (
      <div>
        <div
          className="tagTypeVal"
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.definition1') }}
        ></div>
        <div className="tagTypeVal mt10">
          {formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.definition2')}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.definition3') }}
        ></div>
        <div className="tagTypeVal mt10">
          {formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.definition4')}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.definition5') }}
        ></div>
      </div>
    )
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container pt0">
          <Tabs
            activeKey={tabActive}
            onChange={tabChange}
            items={tabItems}
            tabBarExtraContent={{
              left: (
                <>
                  <Popover
                    trigger="click"
                    color="#f5f5f5"
                    className="mr10 cursorPointer"
                    overlayStyle={{ maxWidth: '75vw', maxHeight: '95vh', overflow: 'auto' }}
                    placement="right"
                    content={getPopoverContent()}
                  >
                    <InfoCircleOutlined />
                    {/* {formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.dataDefinition')} */}
                  </Popover>
                  <Button
                    onClick={downLoadExceptionFun}
                    type="primary"
                    style={{
                      left: isChineseFun().isChinese ? deviceSize * 60 + 80 : deviceSize * 80 + 100,
                      bottom: 5,
                      zIndex: 1,
                      position: 'absolute'
                    }}
                  >
                    {formatMessageNew('languageObj.rfidTunnelScanAccuracyReport.exportExceptions')}
                  </Button>
                </>
              )
            }}
          />
        </div>
      </Card>
    </div>
  )
}
export default RfidTunnelScanAccuracyReport
